import React from "react";
import { Link } from "react-router-dom";
import { getCopy } from "../../content/portfolio";
import { getQaProject } from "../../content/qaProjects";

export default function ProjectPreview({ locale, projectKey, headingLevel = "h2" }) {
  const project = getQaProject(locale, projectKey);
  const copy = getCopy(locale);
  const Heading = headingLevel;
  const isMockup = project.media.hero.includes("-mock-");
  return (
    <article className="qa-project-card">
      <div className={`qa-project-visual${isMockup ? " qa-mockup-frame" : ""}`}>
        <img src={project.media.hero} alt={project.imageAlt} loading="lazy" width="1536" height="1024" />
      </div>
      <div className="qa-project-copy">
        <div className="qa-project-meta bodycopy">
          <span>{project.category}</span>
          <span>{copy.illustrative}</span>
        </div>
        <Heading className="h3">{project.title}</Heading>
        <Link className="qa-project-link bodycopy" to={`/${locale}/projects/${project.slug}`}>{copy.common.viewProject}<span aria-hidden="true"> →</span></Link>
      </div>
    </article>
  );
}
